import { MenuItem, Typography } from '@mui/material'
import * as sxStyles from '../SideNav.style'
import { StyledMenu } from '../SideNav.styled'
import { toast } from 'react-toastify'
import { useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { CompanyRole } from '../../../../types'
import useUserService from '../../../../services/userService'
import { Profile } from '../../../../store/slices/userSlice'
import { successToast } from 'utils/toastService'

type CompanyDropdownTypes = {
  handleSitesMenuClose: () => void
  isSitesMenuOpen: boolean
  user?: Profile
  getCompanyOccurrences: (companyRoles: CompanyRole[]) => any
  anchorEl?: any
}

export const CompanyDropdown = ({
  handleSitesMenuClose,
  isSitesMenuOpen,
  user,
  getCompanyOccurrences,
  anchorEl,
}: CompanyDropdownTypes) => {
  const { switchTenant } = useUserService()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const handleChangeCompany = async (companyId: number, roleId: number) => {
    try {
      const response = await switchTenant(companyId, roleId)
      if (response.status) {
        successToast(response.detail)
        await queryClient.invalidateQueries('user-profile')
        await queryClient.invalidateQueries('user-permissions')
        await queryClient.invalidateQueries('fetch-curr-company-logo')
        navigate('/')
      } else {
        toast.error(response.detail || 'Error while changing the company')
      }
    } catch (error) {
      toast.error(error?.message || 'Error while changing the company')
    }

    handleSitesMenuClose()
  }

  return (
    <StyledMenu
      id="sites-menu"
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      anchorEl={anchorEl}
      open={isSitesMenuOpen}
      onClose={handleSitesMenuClose}
    >
      {user?.company_roles?.map((item, index) => {
        const companyOccurrences = getCompanyOccurrences(
          user?.company_roles || []
        )

        return (
          <MenuItem
            key={index}
            onClick={() => handleChangeCompany(item.company_id, item.role_id)}
            disableRipple
            sx={{
              background:
                item.company_id === Number(user?.company?.id) &&
                item.role_id === user?.role?.id
                  ? (theme) => theme.palette.customGrey.two
                  : 'unset',
            }}
          >
            <Typography
              sx={{
                ...sxStyles.siteMenuTypography,
                fontWeight:
                  item.company_id === Number(user?.company?.id) &&
                  item.role_id === user?.role?.id
                    ? 'bold'
                    : 'normal',
              }}
            >
              {item?.company_name}
              {companyOccurrences[item.company_id] > 1
                ? ` (${item?.role_name})`
                : ''}
            </Typography>
          </MenuItem>
        )
      })}
    </StyledMenu>
  )
}
